import { useId } from 'react'

export const useUniqueDef = (): { id: string; url: string } => {
  const id = useId()
  const url = `url(#${id})`
  return { id, url }
}
